module.exports = __webpack_public_path__ + "static/img/user.38dff892.png";